import { onDocumentReady, Carousel } from "@story/story_assets";
import { onCookiesConsentReady } from "@story/story_cookies_consent";

import "@story/story_cookies_consent/cookies_consent_modal";
import "@story/story_cookies_consent/cookies_consent_link";
import "@story/story_assets/modal/modal_dialog";
import "@story/story_assets/modal/modal_gallery";
import "@story/story_assets/slide";
import "@story/story_assets/snippets";

import "@story/story_assets/ajax_form";
import "@story/story_assets/turnstile";
import "@story/story_assets/snippets";

import "./components/redirect";

// import "./components/smap";
import "./components/forms";
import "./components/scroll";
import "./components/idle_timer";
import "./components/multihover";
import "./components/images";
import "./components/bonds";
import "./components/remote_links";
import "./components/service_filter";
import "./components/filter_modal";

onDocumentReady(function() {
	// *************************************************************************
	// Detect webp
	// *************************************************************************


	// check_webp_feature:
	//   'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'.
	//   'callback(feature, result)' will be passed back the detection result (in an asynchronous way!)
	function check_webp_feature(feature, callback) {
		var kTestImages = {
			lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
			lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
			alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
			animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
		};
		var img = new Image();
		img.onload = function() {
			var result = (img.width > 0) && (img.height > 0);
			callback(feature, result);
		};
		img.onerror = function() {
			callback(feature, false);
		};
		img.src = "data:image/webp;base64," + kTestImages[feature];
	}


	check_webp_feature("lossy", function(feature, result) {
		if (!result) {
			document.body.classList.add("no-webp");
		}
	});

});

onDocumentReady(function() {
	for (let carousel of document.querySelectorAll(".carousel")) {
		new Carousel(carousel);
	}
});


onCookiesConsentReady(function(allowed, changes) {
	if (allowed.includes("marketing")) {
		gtag('consent', 'update', {
			'ad_storage': 'granted',
			'ad_user_data': 'granted',
			'ad_personalization': 'granted',
			'analytics_storage': 'granted'
		});
	}
	else if (allowed.includes("analytic")) {
		gtag('consent', 'update', {
			'ad_storage': 'granted',
			'ad_user_data': 'granted',
			'ad_personalization': 'granted',
			'analytics_storage': 'granted'
		});
	}
	else {
		gtag('consent', 'update', {
			'ad_storage': 'denied',
			'ad_user_data': 'denied',
			'ad_personalization': 'denied',
			'analytics_storage': 'denied'
		});
	}
});
